<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("goods_receipt_notes")}}</h4>
                <p class="text-subtitle-1">{{$t("receipt_goods_from_account")}}</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <StockJournalView type="GOODS_RECEIPT"/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import StockJournalView from './StockJournalView';
export default {
    components: { StockJournalView },
    name: "GoodsReceipt",
    data() {
        return {
            breadcrumbs: [
                {
                    text: "Inventory Management",
                    disabled: false,
                },
                {
                    text: "Stock Movement",
                    disabled: false,
                },
                {
                    text: "Goods Receipt",
                    disabled: false,
                },
            ],
        };
    },
    
};
</script>
